<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd">新增模型</el-button>
          </div>
        </zv-table>

        <zv-dialog
          width="400px"
          :title="isEdit ? '修改模型' : '新建模型'"
          :showDialog.sync="showFormDialog"
          @close-dialog="closeFormDialog"
        >
          <div slot="content">
            <el-form
              ref="myForm"
              label-width="140px"
              :model="formData"
              :rules="formRules"
              status-icon
            >
              <el-form-item label="模型名称：" prop="pattern_name">
                <el-input v-model="formData.pattern_name" clearable></el-input>
              </el-form-item>
              <el-form-item label="是否开启：" prop="is_open" v-if="isEdit">
                <el-switch
                  v-model="formData.is_open"
                  :inactive-value="0"
                  :active-value="1"
                ></el-switch>
              </el-form-item>
            </el-form>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
          </div>
        </zv-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
export default {
  name: "ModelList",
  mixins: [addFormMixin],
  components: {},
  data() {
    let vm = this;
    return {
      table: {
        api: api.modelList,
        query: {
        },
        searchData: [
          {
            type: "input",
            model: "pattern_name",
            placeholder: "模型名称"
          },
          {
            type: "select",
            model: "pattern_area_type",
            placeholder: "区域类型",
            option: vm.$enums.AreaType.forModelList
          },
          {
            type: "select",
            model: "target_type",
            placeholder: "模型类型",
            option: vm.$enums.ModelTargetType.list
          }
        ],
        columns: [
          {
            title: "模型名称",
            key: "pattern_name",
            minWidth: "150"
          },
          {
            title: "区域类型",
            key: "pattern_area_type",
            render(h, ctx) {
              return h("span", vm.$commFunc.parseAreaType(ctx.row.pattern_area_type));
            }
          },
          {
            title: "模型类型",
            key: "target_type",
            render(h, ctx) {
              return h("span", vm.$commFunc.parseTargeType(ctx.row.target_type));
            }
          },
          {
            title: "创建时间",
            key: "add_time",
            minWidth: "110",
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "最后修改时间",
            key: "update_time",
            minWidth: "110",
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.update_time));
            }
          },
          {
            title: "开启状态",
            key: "is_open",
            minWidth: "80",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: ctx.row.is_open,
                  "inactive-value": 0,
                  "active-value": 1
                  // "inactive-text": "关闭",
                  // "active-text": "开启"
                },
                on: {
                  change(status) {
                    vm.doChangeStatus(status, ctx.row.id);
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "60",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth: "100",
            render(h, ctx) {
              const configBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doConfig.bind(this, ctx.row.id)
                  }
                },
                "模型配置"
              );

              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row.id)
                  }
                },
                "编辑"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"
              );

              let arr = [];

              arr.push(configBtn);
              arr.push(editBtn);
              arr.push(delBtn);

              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
        pattern_name: "",
        is_open: true
      },
      formRules: {
        pattern_name: [
          {
            required: true,
            message: "模型名称不能为空",
            trigger: "blur"
          }
        ]
      },
      adddApi: api.addModel,
      editApi: api.editModel,
      deleteApi: api.deleteModel,
      addSuccessMsg: "添加模型成功",
      editSuccessMsg: "编辑模型成功",
      deleteSuccessMsg: "删除模型成功",
      deleteKey: "id"
    };
  },

  computed: {},

  methods: {
    doAdd() {
      this.$router.push('/data-analysis/createModel' + this.$commFunc.refreshStr())
    },
    doEdit(id) {
      let routeData =this.$router.resolve('/data-analysis/createModel' + this.$commFunc.refreshStr() + '&id=' + id)
      window.open(routeData.href, '_blank');
      
    },
    doConfig(id) {
      this.$router.push('/data-analysis/configModel?id=' + id)
    },
    async doChangeStatus(status, id) {
      await this.editApi({
        id,
        is_open: status
      });
      this.$refs.dataTable.refresh();
      this.$message("状态修改成功!");
    }
  },

  created() {},

  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped></style>
